export default Object.freeze({
  activities: [],
  mobilePatrolActivities: [],
});
